module.exports = __webpack_public_path__ + "static/media/neurotoolkit.90113a35.png";